exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".parent-product[data-v-33d0fe11]{display:flex;padding:1rem}.parent-product .name[data-v-33d0fe11]{margin:0;font-size:16px;font-weight:700}", ""]);

// exports
